import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';

@Component({
  selector: 'app-payment-confirm-dialog',
  templateUrl: './payment-confirm-dialog.component.html',
  styleUrls: ['./payment-confirm-dialog.component.scss'],
  providers: [DatePipe]
})
export class PaymentConfirmDialogComponent implements OnInit {
  myDate: any;
  currentUser: any;
  UsertBal: any;
  constructor( private router: Router,
    public dialogRef: MatDialogRef<PaymentConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe, private tokenStorageService: TokenStorageService
  ) {
    this.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
   }

  ngOnInit() {
    this.currentUser = this.tokenStorageService.getUser();
    this.UsertBal = this.tokenStorageService.getUsertBal();
  }
  closeModal(d: any) {
    if(d==1){
      this.dialogRef.close();
    }else{
      this.dialogRef.close();
      this.router.navigate(['']);
    }
   
  }
  // BackToHome(){
  
  //   //this.dialogRef.close();
  //  this.closeModal();
  //   this.router.navigate(['']);
    
  // }
}
